import { useEffect, useRef, useState } from 'react';
import Head from 'next/head';

export default function InjectedStylesCatcher() {
  const styleTags = useRef([]);
  const [styleTagsCount, setStyleTagsCount] = useState(0);

  /**
   * For an unknown reason, "next/head" will sometimes remove
   * style tags injected into the head by the Avia player.
   * This hook catches any style tags removed from the "head"
   * and adds them to an array to be rendered back into the "head"
   */
  useEffect(() => {
    const head = document.querySelector('head');
    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutationItem) => {
        if (mutationItem.removedNodes.length) {
          mutationItem.removedNodes.forEach((removedNode) => {
            if (removedNode.localName === 'style') {
              // A ref needs to be used so the value isn't stuck
              styleTags.current.push(
                <style dangerouslySetInnerHTML={{ __html: removedNode.innerHTML }} />
              );
              // A state value needs to change to trigger a rerender
              setStyleTagsCount(styleTags.current.length);
            }
          })
        }
      })
    });

    observer.observe(head, { childList: true });
  }, []);

  return styleTagsCount ? (
    <Head>
      {styleTags.current.map((styleTag) => styleTag)}
    </Head>
  ) : null
}
